import { client } from "api";
import { isAxiosError } from "axios";
import { useAuth } from "auth/useAuth";
import createAuthRefreshInterceptor from "axios-auth-refresh";

let token = "";

async function refreshAuthToken(error: unknown) {
    if (isAxiosError(error)) {
        const loginResult = await useAuth.getState().doLogin(error.config?.cancelToken);
        token = loginResult?.authToken ?? "";
        if (!token) {
            throw new Error("Unable to refresh authentication token.");
        }
    }
}

// Create axios auth refresh interceptor for 401s
export function createAuthRefresh() {
    createAuthRefreshInterceptor(client, refreshAuthToken, {
        onRetry: (requestConfig) => {
            // Apply the token to all retried requests
            if (requestConfig.headers) {
                requestConfig.headers.Authorization = "Bearer " + token;
            }

            return requestConfig;
        },
    });
}
